import { render } from "./WeddingViewFormType3.vue?vue&type=template&id=563269c6&lang=true"
import script from "./WeddingViewFormType3.vue?vue&type=script&lang=js"
export * from "./WeddingViewFormType3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__